/* 🔴 21 SETTEMBRE 2026, NOTTE — L'AGGIUNTA NON È PIÙ SILENZIOSA.
   Gaetano: dopo «Aggiungi al carrello» compare un pop up che dice che il
   prodotto è nel carrello e fa scegliere fra continuare a comprare e andare
   alla pagina carrello; se nessuno lo chiude, sparisce dopo 5 secondi.
   Qui sotto `silenzia()` è diventata `preparaNotifica()` (punto 1). Il resto
   — spunta sul bottone, salto del contatore, annuncio a voce — resta com'era.
   La testa qui sotto racconta la decisione del 12 agosto: resta perché
   spiega perché esistono gli altri pezzi, ma non descrive più il pannello.
   `cart_type` deve restare su «notification» (nell'editor: «Notifica pop
   up»): è quello che fa fare ajax a product-form.js e rende il pop up. */

/* ═══════════════════════════════════════════════════════════════════════
   TAIBI · aggiunta silenziosa al carrello
   File nostro. Non tocca nessun file di Dawn: si aggancia a quello che
   Dawn già espone — `subscribe`, `PUB_SUB_EVENTS`, e il custom element
   `<cart-notification>`.

   Deciso il 12 agosto 2026. Dopo il clic NON compare nessun pannello e non
   si apre nessun carrello: il pulsante conferma, il numero in alto salta, il
   cliente continua a sfogliare. La home è fatta per sfogliare, e il carrello
   tipico è da più pezzi — shampoo, balsamo, la spazzola.

   ⚠️ Senza pannello la conferma sul pulsante non è un di più: è l'UNICA
   conferma. Per questo qui c'è anche l'annuncio a voce, che il pannello
   dava per conto suo con il suo `role="dialog"`.
   ═══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var DURATA_SPUNTA = 900; // ms — vedi DAWN-16.md § 5
  var ultimoBottone = null;
  var contoPrecedente = null;
  var annuncio = null;
  var motoRidotto = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ── 1 · il pop up, con il tempo ────────────────────────────────────
     Fino al 21 settembre qui c'era `silenzia()`: `open` sull'istanza era una
     funzione vuota e il pannello non si apriva mai. Adesso si apre, e si
     sostituiscono `open` e `close` sull'ISTANZA come prima: il resto di Dawn
     — `renderContents`, il clic fuori, Esc, i bottoni che chiudono — resta
     intatto.
     ⚠️ IL TEMPO LO TIENE IL CSS. La barretta `.taibi-notifica__tempo` ha
     un'animazione di 5s (`taibi-carrello.css`) e il pop up si chiude al suo
     `animationend`. `:hover` e `:focus-within` la fermano da soli con
     `animation-play-state`: nessun timer da mettere in pausa a mano, e il
     tempo che resta è sempre quello che la barretta mostra.
     ⚠️ IL FUOCO NON SI SPOSTA col mouse e col dito: un pop up che sparisce
     da solo non deve portarsi via il fuoco (Dawn lo spostava e lo chiudeva
     dentro con `trapFocus`). Si sposta solo se l'aggiunta è partita dalla
     TASTIERA (`detail === 0` sul clic, punto 3): lì il fuoco dentro ferma il
     tempo, e chi naviga da tastiera ha tutto il tempo che gli serve.
     ⚠️ Chiudendo, il fuoco torna al bottone solo se era dentro il pop up:
     se il cliente nel frattempo è andato altrove, non lo si riporta indietro. */
  var daTastiera = false;

  function preparaNotifica() {
    var notifica = document.querySelector('cart-notification');
    if (!notifica || notifica.taibiPronta || !notifica.notification) return;
    notifica.taibiPronta = true;

    var pannello = notifica.notification;
    var tempo = pannello.querySelector('.taibi-notifica__tempo');

    notifica.open = function () {
      pannello.classList.add('animate', 'active');
      if (tempo) {
        tempo.classList.remove('corre');
        void tempo.offsetWidth; // riparte da capo anche se il pop up era già aperto
        tempo.classList.add('corre');
      }
      document.body.addEventListener('click', notifica.onBodyClick);
      if (daTastiera) {
        var primo = pannello.querySelector('#cart-notification-button') || pannello;
        window.requestAnimationFrame(function () {
          primo.focus();
        });
      }
      if (typeof notifica.dispatchCartViewEvent === 'function') notifica.dispatchCartViewEvent();
    };

    notifica.close = function () {
      if (!pannello.classList.contains('active')) return;
      var fuocoDentro = pannello.contains(document.activeElement);
      pannello.classList.remove('active');
      if (tempo) tempo.classList.remove('corre');
      document.body.removeEventListener('click', notifica.onBodyClick);
      if (fuocoDentro && notifica.activeElement && typeof notifica.activeElement.focus === 'function') {
        notifica.activeElement.focus();
      }
    };

    if (tempo) {
      tempo.addEventListener('animationend', function () {
        notifica.close();
      });
    }

    /* Esc chiude anche quando il fuoco non è dentro (Dawn lo ascolta solo sul
       pannello, e qui il fuoco di solito resta sulla pagina). */
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && pannello.classList.contains('active')) notifica.close();
    });
  }

  /* ── 2 · la regione che parla ───────────────────────────────────────
     ⚠️ Creata SUBITO e vuota: una regione live viene annunciata quando il
     suo contenuto cambia, e se nasce già piena il lettore di schermo la
     legge all'apertura della pagina o la ignora del tutto. */
  function preparaAnnuncio() {
    if (annuncio) return;
    annuncio = document.createElement('span');
    annuncio.className = 'taibi-solo-lettore';
    annuncio.setAttribute('role', 'status');
    annuncio.setAttribute('aria-live', 'polite');
    document.body.appendChild(annuncio);
  }

  function quanti(n) {
    return n === 1 ? '1 articolo' : n + ' articoli';
  }

  /* ── 3 · la conferma sul pulsante ───────────────────────────────────
     `premuto` al clic — conferma il TOCCO, e arriva subito.
     `fatto` su cartUpdate — conferma il RISULTATO, e arriva quando il
     server ha risposto davvero. ⚠️ Nel mockup non c'era differenza fra le
     due cose perché non c'era un server. Qui sì: mettere la spunta al clic
     vorrebbe dire dichiarare un'aggiunta che potrebbe ancora fallire. */
  /* ⚠️ **Dal 27 agosto 2026 anche i due bottoni della SCHEDA**, su richiesta
     di Gaetano: quello principale e quello della barra appiccicata. Prima la
     conferma c'era solo sulle card della griglia — cioè proprio dove il
     cliente compra di fretta — e mancava dove decide.
     🔴 E qui pesa più che altrove: l'aggiunta è **silenziosa** per scelta, non
     si apre nessun pannello. Sulla scheda il bottone è **l'unica** conferma
     che arriva. */
  var BOTTONI = '.card__pill, .card__aggiungi, .product-form__submit, .taibi-barra-acq__btn';

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest(BOTTONI) : null;
    if (!b || b.disabled || b.tagName === 'A') return;

    ultimoBottone = b;
    daTastiera = e.detail === 0;
    b.classList.remove('premuto');
    void b.offsetWidth; // riavvia l'animazione: senza, il secondo clic non si vede
    b.classList.add('premuto');
  });

  function confermaSulBottone() {
    var b = ultimoBottone;
    if (!b) return;
    b.classList.add('fatto');
    clearTimeout(b.taibiTimer);
    b.taibiTimer = setTimeout(function () {
      b.classList.remove('fatto', 'premuto');
    }, DURATA_SPUNTA);
  }

  /* ── 4 · il salto del contatore ─────────────────────────────────────
     ⚠️ Qui il trucco del riavvio NON serve, e il motivo è importante: la
     pastiglia non viene aggiornata, viene SOSTITUITA. `renderContents()` fa
     `innerHTML = …` su `#cart-icon-bubble`, quindi l'elemento è nuovo ogni
     volta e un'animazione CSS su un elemento appena inserito parte da sola.
     ⚠️ Ma parte SEMPRE: la distinzione fra «nasce» e «cambia» va fatta sul
     conteggio precedente, che leggiamo dall'evento — non dal DOM, che a quel
     punto è già stato sostituito. */
  function animaContatore(nuovoConto) {
    if (motoRidotto.matches) return;
    requestAnimationFrame(function () {
      var pastiglia = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      if (!pastiglia) return;
      var nasce = contoPrecedente === 0 || contoPrecedente === null;
      pastiglia.classList.add(nasce ? 'conta--entra' : 'conta--salta');
    });
  }

  /* ── 5 · l'aggancio ─────────────────────────────────────────────────
     `cartUpdate` lo pubblica product-form.js quando l'aggiunta è andata a
     buon fine, con dentro i dati del carrello. È il posto giusto: un
     listener sul clic direbbe «aggiunto» prima di saperlo. */
  function agganciaEventi() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evento) {
      var conto = evento && evento.cartData ? evento.cartData.item_count : null;
      confermaSulBottone();
      animaContatore(conto);
      if (annuncio && conto !== null) {
        annuncio.textContent = 'Carrello aggiornato: ' + quanti(conto);
      }
      contoPrecedente = conto;
    });

    /* ⚠️ Senza pannello, un errore non lo dice più nessuno. Se l'aggiunta
       fallisce — prodotto esaurito nel frattempo — il pulsante deve smettere
       di sembrare premuto, e la cosa va detta anche a voce. */
    subscribe(PUB_SUB_EVENTS.cartError, function (evento) {
      if (ultimoBottone) ultimoBottone.classList.remove('premuto', 'fatto');
      if (annuncio) {
        annuncio.textContent = (evento && evento.message) || 'Non è stato possibile aggiungere il prodotto.';
      }
    });
  }

  function avvia() {
    /* 🔴 SI ASPETTA LA DEFINIZIONE DELL'ELEMENTO. Questo file è in `defer`
       nel `<head>`, `cart-notification.js` in `defer` nell'header: questo
       gira PRIMA, e `<cart-notification>` non è ancora un elemento di Dawn —
       niente `notification`, niente `onBodyClick`. Il vecchio `silenzia()`
       funzionava lo stesso per caso: una proprietà messa su un elemento non
       ancora definito sopravvive quando il browser lo aggiorna. Qui servono
       i pezzi del costruttore, quindi si aspetta `whenDefined`. */
    if (window.customElements && typeof window.customElements.whenDefined === 'function') {
      window.customElements.whenDefined('cart-notification').then(preparaNotifica);
    } else {
      preparaNotifica();
    }
    preparaAnnuncio();
    agganciaEventi();
    var pastiglia = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    contoPrecedente = pastiglia ? parseInt(pastiglia.textContent, 10) || 0 : 0;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia, { once: true });
  } else {
    avvia();
  }

  /* ⚠️ Nell'editor di temi le sezioni si ricaricano da sole: se l'header
     viene ridisegnato, `<cart-notification>` è un elemento nuovo e va
     preparato di nuovo. */
  document.addEventListener('shopify:section:load', preparaNotifica);
})();
